import { z } from "zod";
import { createOptionalSelectValidator, createSelectValidator } from "../Inputs/Utils/createSelectValidator";

// City schema

export const CitySchema = z.object({
    city: createSelectValidator(
        z.string(),
        "City is required"
    )
});

export const OptionalCitySchema = z.object({
    city: createOptionalSelectValidator(
        z.string()
    )
});